import React from "react";
import { ParallaxLayer } from "@react-spring/parallax";

import Gradient from "../../../assets/coms/background_gradient.webp";
import Haze1 from "../../../assets/coms/background_haze1.webp";
import Haze2 from "../../../assets/coms/background_haze2.webp";
import BackgroundMountain from "../../../assets/coms/mountain_background.webp";
import Stars from "../../../assets/coms/stars.webp";
import Stars1 from "../../../assets/coms/stars1.webp";
import Stars2 from "../../../assets/coms/stars2.webp";
import Satellite from "../../../assets/coms/satellite.webp";
import Exclamation from "../../../assets/coms/exclamation.webp";
import Mountain from "../../../assets/coms/mountain.webp";

interface ComsLayersProps {
	offset: number;
	isFirstVisit: boolean;
	showExclamation: boolean;
}

export const ComsLayers: React.FC<ComsLayersProps> = ({ offset, isFirstVisit, showExclamation }) => (
	<>
		{/* Haze */}
		<ParallaxLayer
			offset={0}
			style={{ zIndex: 1 }}
		>
			<div className="haze-layer">
				<img
					src={Haze1}
					alt="Haze 1"
					className="parallax-image"
				/>
				<img
					src={Haze2}
					alt="Haze 2"
					className="parallax-image"
				/>
			</div>
		</ParallaxLayer>

		{/* Gradient */}
		<ParallaxLayer
			offset={0}
			style={{ zIndex: 2 }}
		>
			<div className="gradient-layer">
				<img
					src={Gradient}
					alt="Gradient"
					className="parallax-image"
				/>
			</div>
		</ParallaxLayer>

		{/* Background Mountain */}
		<ParallaxLayer
			offset={0}
			style={{ zIndex: 3 }}
		>
			<div className="background-mountain">
				<img
					src={BackgroundMountain}
					alt="Background Mountain"
					className="parallax-image"
				/>
			</div>
		</ParallaxLayer>

		{/* Stars */}
		<ParallaxLayer
			offset={0}
			style={{ zIndex: 4 }}
		>
			<div className="stars-layer">
				{[Stars, Stars1, Stars2].map((img, i) => (
					<img
						key={i}
						src={img}
						alt={`Stars ${i + 1}`}
						className="parallax-image"
					/>
				))}
			</div>
		</ParallaxLayer>

		{/* Satellite */}
		<ParallaxLayer
			offset={0}
			style={{ zIndex: 5 }}
		>
			<div className="satellite-container">
				<img
					src={Satellite}
					alt="Satellite"
					className="parallax-image"
				/>
			</div>
		</ParallaxLayer>

		{/* Exclamation */}
		<ParallaxLayer
			offset={1}
			style={{ zIndex: 6 }}
		>
			<div className={`exclamation-container ${showExclamation ? "visible" : ""}`}>
				<img
					src={Exclamation}
					alt="Exclamation"
					className="parallax-image"
				/>
			</div>
		</ParallaxLayer>

		{/* Foreground Mountain */}
		<ParallaxLayer
			offset={0}
			style={{ zIndex: 7 }}
		>
			<div className="foreground-mountain">
				<img
					src={Mountain}
					alt="Mountain"
					className="parallax-image"
				/>
			</div>
		</ParallaxLayer>
	</>
);
